<template lang="pug">
section.onboarding-dem-jobs
    //- Table
    template(v-if="jobs.length === 0")
        .no-results No jobs found

    template(v-else)
        sectionHeader.section-header-jobs(title='Jobs')
        Table(
            :fullData="jobs"
            :tableData="tableData"
            :selectRow="setSelectedRow"
            :selectedRowId="selectedJobId"
            :setActiveTab="setActiveTab"
            defaultTab="file"
            :displaySearch="true"
            :searchFilters="searchFilters"
            searchPlaceHolder="Search jobs by label or id"
            :displayFilters="true"
            :filtersData="filtersData"
            :filterDatesKeys="['Start', 'Update', 'jobs']"
            :dateFilters="dateFilters"
            :defaultDates="defaultDates"
            :filterDateOperators='filterDateOperators'
        )
</template>

<script>
import { formatDate } from '@/utils/helpers'

//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations } from 'vuex'

import Table from '@/components/common/Table'
import SectionHeader from '@/components/common/SectionHeader'

import { JOBS_TABLE_PROPS, JOBS_FILTERS_PROPS, JOBS_SEARCH_PROPS, FILTER_DATE_OPERATORS, FILTERING_DEFAULT_DATES } from '@/utils/constants'

import { cloneDeep } from 'lodash'
import dayjs from 'dayjs'

export default {
    name: 'DataEntryJobs',

    components: { Table, SectionHeader },

    props: {
        jobs: { type: Array, required: true }
    },

    mounted() {
        this.dateFilters = [
            {
                icon: { name: 'calendar', size: 'small' },
                dates: cloneDeep(this.filterStartDate),
                key: 'filterStartDate',
                from: { label: 'Start', placeholder: this.createdOrStartDateFromDefaultValue, pickerOptions: this.pickerOptionsStartFrom },
                to: { label: 'to', placeholder: this.newDate, pickerOptions: this.pickerOptionsStartOrCreatedTo }
            },
            {
                icon: { name: 'calendar', size: 'small' },
                dates: cloneDeep(this.filterEndDate),
                key: 'filterEndDate',
                from: { label: 'Update', placeholder: this.newDate, pickerOptions: null },
                to: { label: 'to', placeholder: this.newDate, pickerOptions: null }
            }
        ]
    },

    data() {
        return {
            // TABLE
            tableData: {
                config: JOBS_TABLE_PROPS.config,
                pagination: {
                    currentPage: JOBS_TABLE_PROPS.pagination.currentPage,
                    currentPageSize: JOBS_TABLE_PROPS.pagination.rowPerPage
                },
                sorting: JOBS_TABLE_PROPS.sorting,
                opened: []
            },

            // SEARCH
            searchFilters: cloneDeep(JOBS_SEARCH_PROPS),

            // FILTERS
            filtersData: {
                filters: cloneDeep(JOBS_FILTERS_PROPS),
                filterTargets: { bootstrap: '', status: '', type: '', shared: '' }
            },

            // DATE FILTERS
            dateFilters: [],
            filterDateOperators: FILTER_DATE_OPERATORS,
            filterStartDate: cloneDeep(FILTERING_DEFAULT_DATES.start),
            filterEndDate: cloneDeep(FILTERING_DEFAULT_DATES.end),
            defaultDates: cloneDeep(FILTERING_DEFAULT_DATES)
        }
    },

    computed: {
        ...mapState('ui/dataEntry', {
            selectedJobId: state => state.selectedRowId
        }),

        // DATE FILTERS
        newDate() {
            return formatDate(new Date())
        },
        createdOrStartDateFromDefaultValue() {
            return formatDate(dayjs(this.newDate).subtract(3, 'weeks'))
        },
        pickerOptionsStartFrom() {
            const _filterStartDate = this.filterStartDate
            if (this.disabledStartPeriodFilter) {
                return {
                    disabledDate(time) {
                        return time ? time.getTime() > Date.now() : null
                    }
                }
            } else {
                return {
                    disabledDate(time) {
                        return time ? time.getTime() > _filterStartDate.to.getTime() : null
                    }
                }
            }
        }
    },

    methods: {
        // Call to mutations
        ...mapMutations('ui/dataEntry', ['setSelectedRow', 'setActiveTab'])
    }
}
</script>
